export enum SessionStorage {
  COUNTRY_CODE = 'country_code',
  CITY_CANONICAL = 'city_canonical',
}
